module.exports = __webpack_public_path__ + "static/media/microsoftcolor.14261757.svg";